import React, {PropsWithChildren} from "react";
import {BrandingBar} from "./branding-bar";
import {Alert, Box, CircularProgress, Container, Stack} from "@mui/material";

interface AppLayoutProps {
	showBrandingBar: boolean;
	loading?: boolean;
	error?: Error;
	gutterTop?: boolean;
}

export function AppLayout({showBrandingBar, loading, error, gutterTop, children}: PropsWithChildren<AppLayoutProps>) {
	return (
		<>
			{showBrandingBar && <BrandingBar />}

			<Box
				sx={{
					width: '100%',
					mt: gutterTop ? 2 : 0,
				}}
			>
				{(loading || error !== undefined) && (
					<Container
						maxWidth="md"
						sx={{
							mt: showBrandingBar ? 2 : 0,
						}}
					>
						{loading && (
							<Stack
								direction="column"
								alignItems="center"
							>
								<CircularProgress />
							</Stack>
						)}

						{error && (
							<Alert severity="error">
								{error.message ?? 'Error'}
							</Alert>
						)}
					</Container>
				)}

				{children}
			</Box>

		</>
	)
}
